<template>
  <div>
    <section class="section more-space has-background-dark">
      <div class="container has-text-centered">
        <h1 class="title is-1 has-text-light">
          {{ $product.title }}
        </h1>
        <h2
          class="subtitle is-3 has-text-light"
          v-html="$product.subtitle"
        />
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column">
            <p
              class="is-size-3"
              v-html="$product.description"
            />
          </div>
          <div class="column">
            <figure class="image">
              <img :src="$product.image">
            </figure>
          </div>
        </div>
        <div id="Features">
          <div class="columns">
            <div
              v-for="(feature, index) in $product.features"
              :key="index"
              class="column"
            >
              <Feature
                :icon="feature.icon"
                :title="feature.title"
                :description="feature.description"
              />
            </div>
          </div>
        </div>
        <div id="Collaboration">
          <p
            class="is-size-3"
            v-html="$product.collaboration"
          />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Feature from '../components/Landing/Feature.vue';

export default {
  components: {
    Feature,
  },
  mounted() {
    if (this.$route.matched.some((record) => record.meta.registrationFlow)) {
      this.$iam.login();
    }
  },
};
</script>
<style scoped>
/* Colors */

.more-space {
  padding-top: 5em;
  padding-bottom: 3em;
}

/* Spacing */

h2.subtitle {
  padding-top: 0.25em;
}
#Collaboration {
  margin-top: 5em;
}
#Features {
  margin-top: 4em;
}
</style>
